import { render, staticRenderFns } from "./IssueTrackingIndex.vue?vue&type=template&id=4b9f7c70"
import script from "./IssueTrackingIndex.vue?vue&type=script&lang=js"
export * from "./IssueTrackingIndex.vue?vue&type=script&lang=js"
import style0 from "./IssueTrackingIndex.vue?vue&type=style&index=0&id=4b9f7c70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports